import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormControl, FormBuilder, FormGroup, Validators } from "@angular/forms";

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { SwiperModule, SWIPER_CONFIG, SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { LazyLoadImageModule, intersectionObserverPreset } from 'ng-lazyload-image';

import { SharingModule } from '../SharedModule';

import { PageRoutingModule } from './page-routing.module';
import { PageComponent } from './page.component';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { IntroContentComponent } from '../intro-content/intro-content.component';
import { TabComponent } from '../tab/tab.component';
import { ConvenorComponent } from '../convenor/convenor.component';
import { PhotosVideosComponent } from '../photos-videos/photos-videos.component';
import { InquiryComponent } from '../inquiry/inquiry.component';
import { RegisterComponent } from '../register/register.component';
import { EngageComponent } from '../engage/engage.component';
import { CommunityComponent } from '../community/community.component';
import { ContentComponent } from '../content/content.component';
import { SpeakerComponent } from '../speaker/speaker.component';
import { FaqComponent } from '../faq/faq.component';
import { DynamicformComponent } from '../dynamicform/dynamicform.component';
import { ContentTabComponent } from '../content-tab/content-tab.component';
import { PressEventsComponent } from '../press-events/press-events.component';
import { TwoColumnComponent } from '../two-column/two-column.component';
import { BookInterviewComponent } from '../book-interview/book-interview.component';
import { SocialMediaComponent } from '../social-media/social-media.component';
import { TeamComponent } from '../team/team.component';
import { SingleColumnComponent } from '../single-column/single-column.component';
// import { FeedComponent } from '../feed/feed.component';
// import { ParticipantsComponent } from '../participants/participants.component';
import { InnernewsComponent } from '../innernews/innernews.component';
// import { OrganisationsComponent } from '../organisations/organisations.component';
import { PartnerTabComponent } from '../partner-tab/partner-tab.component';
import { BlurbComponent } from '../blurb/blurb.component';
import { SiblingComponent } from '../sibling/sibling.component';
import { EngageTabComponent } from '../engage-tab/engage-tab.component';
import { InnerNewsletterComponent } from '../inner-newsletter/inner-newsletter.component';
import { FormModalComponent } from '../form-modal/form-modal.component';
import { IframFormModalComponent } from '../ifram-form-modal/ifram-form-modal.component';
import { FactComponent } from '../fact/fact.component';
import { QuoteComponent } from '../quote/quote.component';
import { DoubleContentComponent } from '../double-content/double-content.component';
import { FileComponent } from '../file/file.component';
import { HomeBannerComponent } from '../home-banner/home-banner.component';
import { HomeNewsComponent } from '../home-news/home-news.component';
import { WpEngageComponent } from '../wp-engage/wp-engage.component';
import { WpEngageTabComponent } from '../wp-engage-tab/wp-engage-tab.component';
import { BlurbTabComponent } from '../blurb-tab/blurb-tab.component';
import { DoubleContentTabComponent } from '../double-content-tab/double-content-tab.component';
import { FileTabComponent } from '../file-tab/file-tab.component';
import { ImagevideoTabComponent } from '../imagevideo-tab/imagevideo-tab.component';
import { PageAccordionComponent } from '../page-accordion/page-accordion.component';
import { AccordionTabComponent } from '../accordion-tab/accordion-tab.component';


const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
	direction: 'horizontal',
	slidesPerView: 'auto'
};

import { DropzoneModule, DROPZONE_CONFIG, DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { NgxDropzoneModule } from 'ngx-dropzone';

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {};

@NgModule({
	imports: [
		NgbModule,
		HttpClientModule,
		HttpClientJsonpModule,
		CommonModule,
		PageRoutingModule,
		SharingModule.forRoot(),
		FormsModule,
		ReactiveFormsModule,
		SwiperModule,
		LazyLoadImageModule.forRoot({
			preset: intersectionObserverPreset
		}),
		NgxDropzoneModule,
    	DropzoneModule,
	],
	declarations: [
		PageComponent,
		BreadcrumbComponent,
		IntroContentComponent,
		TabComponent,
		ConvenorComponent,
		PhotosVideosComponent,
		InquiryComponent,
		RegisterComponent,
		EngageComponent,
		CommunityComponent,
		ContentComponent,
		SpeakerComponent,
		FaqComponent,
		DynamicformComponent,
		ContentTabComponent,
		PressEventsComponent,
		TwoColumnComponent,
		BookInterviewComponent,
		SocialMediaComponent,
		TeamComponent,
		SingleColumnComponent,
		// FeedComponent,
		// ParticipantsComponent,
		InnernewsComponent,
		// OrganisationsComponent,
		PartnerTabComponent,
		FormModalComponent,
		IframFormModalComponent,
		BlurbComponent,
		SiblingComponent,
		EngageTabComponent,
		InnerNewsletterComponent,
		FactComponent,
		QuoteComponent,
		DoubleContentComponent,
		FileComponent,
		HomeBannerComponent,
		HomeNewsComponent,
		WpEngageComponent,
		WpEngageTabComponent,
		BlurbTabComponent,
		DoubleContentTabComponent,
		FileTabComponent,
		ImagevideoTabComponent,
		PageAccordionComponent,
		AccordionTabComponent,
	],
	schemas: [
		CUSTOM_ELEMENTS_SCHEMA,
		NO_ERRORS_SCHEMA,
	],
	entryComponents: [
		FormModalComponent,
		IframFormModalComponent,		
	],
	providers: [
		{
			provide  : SWIPER_CONFIG,
			useValue : DEFAULT_SWIPER_CONFIG
		},
		{
			provide: DROPZONE_CONFIG,
			useValue: DEFAULT_DROPZONE_CONFIG
	    },
	]
})
export class PageModule { }